import { get } from '@/httpRequest'

export interface IUserCheckIsFollowedRequest {
  user_id: string
}

export interface IUserCheckIsFollowedResponse {
  is_followed: boolean
}

export const getUserCheckIsFollowed = async (
  params: IUserCheckIsFollowedRequest
) => {
  const response = await get<IUserCheckIsFollowedResponse>(
    `/user/checkIsFollowed`,
    params
  )

  return response
}
